import React, { PropsWithChildren } from 'react'

import { ReactFC } from 'common/types/ReactFC'
import Button from 'components/forms/Button'
import useWindowSize from 'components/util/useWindowSize'
import { generateSrcSet } from 'project/image-proxy-web'
import Link from 'next/link'
import classNames from 'classnames'
import { Tenant } from 'common/tenant'

type PartnersCardType = {
  book?: boolean
  tenant?: Tenant
}

const PartnersCard: ReactFC<PropsWithChildren<PartnersCardType>> = ({
  book,
  tenant = Tenant.UK,
}) => {
  const size = useWindowSize()

  return (
    <div className='card card_bg-gradient-purple-pink partners-card overflow-hidden'>
      <div className='pt-8 pt-lg-9 px-5 pe-lg-0 ps-lg-20 position-relative'>
        <div>
          <h3 className='text-start text-lg-center pe-20 lh-105 color-white fw-semibold fs-fluid-40-80'>
            Trusted by leading financial <br className='d-none d-lg-block' />{' '}
            institutions — serving <br className='d-none d-lg-block' /> 100,000+
            customers to date.
          </h3>
          {!book && (
            <>
              <div
                className='d-flex gap-0 align-items-center justify-content-between mt-10 mt-lg-0'
                style={
                  size.isLgOrHigher
                    ? {
                        marginTop: -25,
                      }
                    : {}
                }
              >
                <Link
                  href={tenant === Tenant.AU ? '/au/enterprise' : '/enterprise'}
                >
                  <Button
                    theme='outlineWhite'
                    className='color-white w-100 w-lg-auto mb-14'
                    style={{
                      minWidth: 208,
                    }}
                  >
                    Find out more
                  </Button>
                </Link>
                <div />

                {size.isLgOrHigher && (
                  <div className='d-flex align-items-end justify-content-end w-100'>
                    <img
                      {...generateSrcSet(
                        '/images/new/arm-pointing-left.png',
                        1032,
                        364,
                      )}
                      height={364}
                      width={1032}
                      alt='Robot arm pointing left'
                      className='img-fluid'
                      loading='lazy'
                    />
                  </div>
                )}
              </div>
            </>
          )}
        </div>
        {!size.isLgOrHigher && !book && (
          <img
            {...generateSrcSet('/images/new/arm-pointing-down.png', 128, 251)}
            alt='Robot arm pointing down'
            className='position-absolute arm-point-down-img'
            loading='lazy'
          />
        )}
      </div>
      <div
        className={classNames('partners-marquee-container pb-10 pb-lg-9', {
          'mt-9': !!book,
        })}
      >
        <div className='partners-marquee'>
          <img
            {...generateSrcSet('/images/logos/partners/partners.svg', 816, 72)}
            className='pe-54 h-auto w-auto'
            alt='partners'
            height={72}
            width={816}
            loading='lazy'
          />
          <img
            {...generateSrcSet('/images/logos/partners/partners.svg', 816, 72)}
            className='pe-54 h-auto w-auto'
            alt='partners'
            height={72}
            width={816}
            loading='lazy'
          />
        </div>
      </div>
      {!!book && (
        <div className='mt-lg-6 pb-lg-14 pb-8 mx-4 mx-lg-0 text-center'>
          <a
            className='btn btn-lg btn-outline-white w-100 w-lg-auto'
            href='#konnect-form'
          >
            Book a Demo
          </a>
        </div>
      )}
    </div>
  )
}

export default PartnersCard
